// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3C_WL","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2OqUi"};